

























































import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator'
import Competence from '@/competences/entities/competence'
import CompetencesService from '@/competences/services/competences-service'
import CompetenceDialog from '@/competences/components/competence-dialog.vue'
import QuestionsDialog from '@/competences/components/questions-dialog.vue'
import CompetenceFilter from '@/competences/entities/competence-filter'
import bus from '@/app/bus'

@Component
export default class Competences extends Vue {
  @Ref()
  private dialog!: CompetenceDialog
  @Ref()
  private questionsDialog!: QuestionsDialog
  @Ref()
  private fileInput!: HTMLInputElement

  private loading: boolean = false
  private filter = new CompetenceFilter()
  private competences: Competence[] = []
  private importResult = ''
  private showImportResult = false

  @Watch('filter', { deep: true })
  private async paginationChanged() {
    await this.fetchAll()
  }

  private async fetchAll() {
    this.loading = true
    const response = await CompetencesService.findAllPagedAsync(this.filter)
    this.competences = response.items
    this.filter.paging.totalItems = response.totalItems
    this.loading = false
  }

  private openNew() {
    const competence = new Competence()
    // Competences created in this view are always Templates.
    competence.isTemplate = true
    this.dialog.openNew(competence)
  }

  private edit(competence: Competence) {
    this.dialog.openEdit(competence)
  }

  private async create(competence: Competence) {
    await CompetencesService.createAsync(competence)
    await this.fetchAll()
    this.dialog.close()
  }

  private async update(competence: Competence) {
    await CompetencesService.updateAsync(competence)
    await this.fetchAll()
    this.dialog.close()
  }

  private openQuestions(competence: Competence) {
    this.questionsDialog.openQuestions(competence)
  }

  private async remove(competence: Competence) {
    await CompetencesService.removeAsync(competence.id)
    await this.fetchAll()
  }

  private async upload(e: Event) {
    const elem = e.target as HTMLInputElement
    if (elem.files && elem.files.length === 1) {
      this.importResult = await CompetencesService.importAsync(elem.files[0])
      this.showImportResult = true
      await this.fetchAll()
      elem.files = new DataTransfer().files
    }
  }

  private showInfo() {
    bus.$emit(
      'app.help-dialog.show',
      `
    <h2 name="competences">Kompetenzbibliothek</h2>
    <br/>
    <p>
      Die Kompetenzbibliothek ist eine Sammlung von Kompetenzen, die dabei helfen
      soll, Fähigkeiten von Bewerber:innen abzufragen und zu beurteilen.
    </p>
    <p>
      Neben den Kompetenzen die standardmäßig im System hinterlegt sind, haben Sie
      hier auch die Möglichkeit, eigene Kompetenzen zu ergänzen. Diese Kompetenzen
      können dann im Zuge einer Evaluierung ausgewählt werden.
    </p>
    `
    )
  }

  private mounted() {
    this.filter.isTemplate = true
  }
}
